
const url = require('url');

const _ = require('lodash');

const Q = require('q');
const $ = require('jquery');

const Config = require('config/js/lib/config.js');

const domains = require('../domains');
const siteID = require('../siteID');


module.exports = new Config(function () {
	return Q.Promise(function (resolve, reject) {
		$(function () {
			try {
				resolve(JSON.parse($('#cms-data-page-urls-config').html()));
			} catch (e) {
				reject(e);
			}
		});
	})
		.then(cfg => {
			// map domain names from canonical to environment-local (www.rgs.ru -> www.stg.rgs-dev.epam.com)
			return domains.get().then(domainsMap => {
				function transform (cfg) {
					if (_.isString(cfg)) {
						const parsed = url.parse(cfg);
						return url.format(_.extend({}, parsed, {
							hostname: undefined,
							host: domainsMap[parsed.hostname] || parsed.hostname,
						}));
					}
					return _.mapValues(cfg, transform);
				}
				return transform(cfg);
			});
		})
		.then(cfg => {
			// add `currentSite`
			return siteID.get().then(siteID => {
				return _.defaults({
					currentSite: cfg[siteID],
				}, cfg);
			});
		});
});

